import styles from './FilterChip.module.css';

interface FilterChipProps {
  label: string;
  selected: boolean;
  onChange: (selected: boolean) => void;
  dotColor?: string;
}

export default function FilterChip({
  label,
  selected,
  onChange,
  dotColor,
}: FilterChipProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={selected}
      className={`${styles.chip} ${selected ? styles.chipSelected : ''}`}
      onClick={() => onChange(!selected)}
    >
      {dotColor && (
        <span className={styles.dot} style={{ backgroundColor: dotColor }} />
      )}
      {label}
    </button>
  );
}
